import { BranchEventProperties } from 'api/branch/types';
import PageTypes from './PageTypes';

export interface State {
  eventSent: boolean;
  pageType: PageTypes;
  branchData?: BranchEventProperties;
  deepLink?: string;
}

export const initialState: State = {
  eventSent: false,
  pageType: PageTypes.Unknown
};

export type Action =
  | {
      type: 'TRACK_PAGE_VIEW';
      pageType: PageTypes;
      branchData?: BranchEventProperties;
      deepLink?: string;
      isSendEvent: boolean;
    }
  | { type: 'EVENT_SENT'; eventSent: boolean }
  | { type: 'PAGE_CHANGED' };

export function reducer(state: State, action: Action) {
  switch (action.type) {
    case 'TRACK_PAGE_VIEW':
      return {
        pageType: action.pageType,
        branchData: action.branchData,
        deepLink: action.deepLink,
        eventSent: state.eventSent || !action.isSendEvent
      };
    case 'EVENT_SENT':
      return {
        ...state,
        eventSent: action.eventSent
      };
    case 'PAGE_CHANGED':
      return initialState;
    default:
      return state;
  }
}
